"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var loadArticles = function loadArticles(params) {
  return {
    type: 'OLY_LOAD_ARTICLES',
    payload: _objectSpread({}, params)
  };
};

var loadArticlesSuccess = function loadArticlesSuccess(payload) {
  return {
    type: 'OLY_LOAD_ARTICLES_SUCCESS',
    payload: payload
  };
};

var loadArticlesError = function loadArticlesError() {
  return {
    type: 'OLY_LOAD_ARTICLES_ERROR'
  };
};

var resetArticles = function resetArticles() {
  return {
    type: 'OLY_RESET_ARTICLES'
  };
};

var loadArticlesFromCollection = function loadArticlesFromCollection(params) {
  return {
    type: 'OLY_LOAD_ARTICLES_FROM_COLLECTION',
    payload: _objectSpread({}, params)
  };
};

var loadArticlesFromCollectionSuccess = function loadArticlesFromCollectionSuccess(payload) {
  return {
    type: 'OLY_LOAD_ARTICLES_FROM_COLLECTION_SUCCESS',
    payload: payload
  };
};

var loadArticlesFromCollectionError = function loadArticlesFromCollectionError() {
  return {
    type: 'OLY_LOAD_ARTICLES_FROM_COLLECTION_ERROR'
  };
};

var resetArticlesFromCollection = function resetArticlesFromCollection() {
  return {
    type: 'OLY_RESET_ARTICLES_FROM_COLLECTION'
  };
};

var _default = {
  loadArticles: loadArticles,
  loadArticlesSuccess: loadArticlesSuccess,
  loadArticlesError: loadArticlesError,
  resetArticles: resetArticles,
  loadArticlesFromCollection: loadArticlesFromCollection,
  loadArticlesFromCollectionSuccess: loadArticlesFromCollectionSuccess,
  loadArticlesFromCollectionError: loadArticlesFromCollectionError,
  resetArticlesFromCollection: resetArticlesFromCollection
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map